import React, {useEffect, useState} from "react";
import TextField from "@mui/material/TextField/TextField";
import Button from "@mui/material/Button";
import {clearCredentials, errorMessage, getCredentials, post, saveCredentials} from "./api2026";

// Logs the player in with the stored credentials, or displays the form
export const Login2026 = ({setPlayer}) => {

    const [username, setUsername] = useState(getCredentials().username);
    const [password, setPassword] = useState(getCredentials().password);
    const [error, setError] = useState("");
    const [displayForm, setDisplayForm] = useState(false);

    useEffect(() => {
        if (username && password) {
            login();
        } else {
            setDisplayForm(true);
        }
    }, []);

    function login() {
        if (!username || !password) {
            return;
        }
        setError("");
        saveCredentials(username, password);
        post("/login").then(data => {
            setPlayer(data.player);
        }).catch(err => {
            clearCredentials();
            setError(errorMessage(err));
            setDisplayForm(true);
        });
    }

    if (!displayForm) {
        return <div style={{textAlign: "center"}}>Connexion...</div>;
    }

    return (
        <form className="anniv2026-login" onSubmit={(e) => {
            e.preventDefault();
            login();
        }}>
            <TextField
                placeholder="Nom"
                variant="outlined"
                size="small"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                required
            />
            <TextField
                type="password"
                placeholder="Mot de passe"
                variant="outlined"
                size="small"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
            />
            <Button variant="contained" type="submit">Se connecter</Button>
            {error && <p style={{color: "#EA1F70"}}>{error}</p>}
        </form>
    );
}
